import instance from "../redux/actions/AxiosInstance/authenticated";

export const fetchWalmartProductDetails = async (
  product_id,
  addToHistory = "true"
) => {
  try {
    const response = await instance.post("/walmart/product", {
      product_id,
      addToHistory,
    });
    return response?.data;
  } catch (error) {
    console.error("Error fetching Walmart product details:", error);
  }
};

export const fetchWalmartSellers = async (product_id) => {
  try {
    const response = await instance.post("/walmart/sellers", {
      product_id,
    });
    return response?.data;
  } catch (error) {
    console.error("Error fetching Walmart sellers:", error);
  }
};

export const fetchWalmartReviews = async (product_id, page = 1) => {
  try {
    const response = await instance.post("/walmart/reviews", {
      product_id,
      page,
    });
    return response?.data;
  } catch (error) {
    console.error("Error fetching Walmart reviews:", error);
  }
};

